import { render, staticRenderFns } from "./ReportTeethWidget.vue?vue&type=template&id=2eec172c&scoped=true&"
import script from "./ReportTeethWidget.vue?vue&type=script&lang=ts&"
export * from "./ReportTeethWidget.vue?vue&type=script&lang=ts&"
import style0 from "./ReportTeethWidget.vue?vue&type=style&index=0&id=2eec172c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eec172c",
  null
  
)

export default component.exports